<div [style]="styling" [matTooltip]="type" class="discount-info">
    <span *ngIf="iconToDisplay">
        <fa-icon [icon]="iconToDisplay" size="1x"></fa-icon>
    </span>
    <span class="value">{{discountToShow | number: '1.0-2'}}%</span>
</div>